import React, { useState, useEffect, useContext } from 'react'
import Button from '@/components/Button'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import SiteContext from '@/context/SiteContext'
import { rutValidate, rutFormat } from 'rut-helpers'
import axios from 'axios'

const Label = styled.label`
  ${tw`border rounded-md border-gray-400 bg-white focus:border-azul w-full py-1 px-1 pl-4 leading-none`}
  display: grid;
  grid-template-columns: 30px auto auto;
  align-items: center;
  @media (orientation: portrait) {
    grid-template-columns: 30px auto 100px;
  }
  .irut {
    ${tw`appearance-none outline-none bg-white`}
  }
`

const useForm = ({ initialValues, onSubmit, validate }) => {
  const [values, setValues] = useState(initialValues || {})
  const [touchedValues, setTouchedValues] = useState({})
  const [errors, setErrors] = useState({})

  const handleChange = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    setValues({
      ...values,
      [name]: value,
    })
  }

  const handleBlur = event => {
    const target = event.target
    const name = target.name
    setTouchedValues({
      ...touchedValues,
      [name]: true,
    })
    const e = validate(values)
    setErrors({
      ...errors,
      ...e,
    })
  }

  const handleSubmit = event => {
    event.preventDefault()
    const e = validate(values)
    setErrors({
      ...errors,
      ...e,
    })
    onSubmit({ values, e })
  }

  return {
    values,
    touchedValues,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
  }
}

const Form = () => {
  const sitecontext = useContext(SiteContext)
  const {
    values,
    touchedValues,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm({
    initialValues: {
      rut: '',
    },
    onSubmit(values) {
      values.values.rut = rutFormat(values.values.rut)
      const err = values.e ? values.e : null
      const val = values.values ? values.values : null

      if (Object.keys(err).length > 0) {
        console.log('nope:', err)
      } else {
        sitecontext.saveRut(val.rut)
        console.log('info acumulada', sitecontext.infoacumulada)
        const rutprevio = sitecontext.infoacumulada.find(
          rutconsultado => rutconsultado.rut === val.rut,
        )

        if (rutprevio) {
          sitecontext.setRutData(rutprevio)
        } else {
          axios
            .post(
              `https://ganbpwa5s0.execute-api.us-east-2.amazonaws.com/pdata`,
              {
                rut: val.rut,
              },
            )
            .then(res => {
              sitecontext.addToInfo(res.data)
            })
        }
      }
    },
    validate(values) {
      const errorobj = {}
      if (values.rut === '') {
        errorobj.rut = 'Ingresa un RUT'
      } else if (!rutValidate(values.rut)) {
        errorobj.rut = 'RUT inválido'
      }
      return errorobj
    },
  })
  return (
    <form onSubmit={handleSubmit}>
      <Label>
        <svg
          viewBox="0 0 16 16"
          width="16"
          height="16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          shapeRendering="geometricPrecision">
          <circle class="st0" cx="8" cy="8" r="6.5" />
          <polyline class="st0" points="7,5.5 9.5,8 7,10.5 " />
        </svg>
        <input
          type="text"
          className="irut"
          name="rut"
          value={rutFormat(values.rut)}
          onChange={handleChange}
          placeholder="Ejemplo: 15.123.456-7"
        />
        <Button
          type="submit"
          as="button"
          className="py-3 bg-azul text-white border-azul">
          Continuar
        </Button>
      </Label>
      {errors && <span>{errors.rut}</span>}
    </form>
  )
}

export default Form
